import { setAlertError, setAlertSuccess } from '@/utils/store/alert'
import IntegrationAmoCrmController
  from '@/controllers/adminPanel/settings/IntegrationAmoCrm/IntegrationAmoCrmController'

export default {
  namespaced: true,
  state: {
    tokens: [],
    isLoading: false,
    isLoadingForSet: false
  },

  getters: {
    tokens: state => state.tokens,
    isLoading: state => state.isLoading,
    isLoadingForSet: state => state.isLoadingForSet
  },

  mutations: {
    SET_TOKENS (state, tokens) {
      state.tokens = tokens
    },
    SET_IS_LOADING (state, loading) {
      console.log('set', loading)
      state.isLoading = loading
    },

    SET_IS_LOADING_FOR_SET (state, loading) {
      console.log('set', loading)
      state.isLoadingForSet = loading
    }
  },
  actions: {
    // Получение токена AmoCrm
    async getToken ({ commit }) {
      try {
        commit('SET_IS_LOADING', true)

        const response = await IntegrationAmoCrmController.getToken()
        commit('SET_TOKENS', response.data)
      } catch (e) {
        await setAlertError(e, 'Не удалось получить токен AmoCrm')
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    // Установка токена AmoCrm
    // data: {
    //     "access_token": "...",
    //     "deadline": "2030-12-31"
    // }
    async setToken ({ commit }, data) {
      try {
        commit('SET_IS_LOADING_FOR_SET', true)

        const response = await IntegrationAmoCrmController.setToken(data)
        commit('SET_TOKENS', response.data)

        if (response.status === 200) await setAlertSuccess('Токен успешно сохранён')
      } catch (e) {
        await setAlertError(e, 'Не удалось получить токен AmoCrm')
      } finally {
        commit('SET_IS_LOADING_FOR_SET', false)
      }
    }
  }
}
